
export default {
  data () {
    return {
      isLoading: false,
    }
  },
  methods: {
    start () {
      this.isLoading = true
    },
    finish () {
      this.isLoading = false
    }
  }
}
